import { registerBlock } from "../../registry";
import { makeId } from "../../helpers";
import type { ContentBlock } from "../../types";

const eggRetrieval: ContentBlock<"module"> = {
  id: makeId("module-egg-retrieval"),
  kind: "module",
  tags: ["her", "treatment", "during-cycle"],
  title: "Egg Retrieval",
  subtitle: "Outpatient procedure to collect mature eggs",
  icon: "🥚",
  body: {
    duration: "1 day",
    category: "treatment",
    forWhom: "her",
    includes: [
      "Pre-procedure prep guidance (fasting, arrival time)",
      "Egg retrieval under light sedation (~20 minutes)",
      "Recovery room monitoring (1–2 hours)",
      "Same-day egg count report",
      "Post-retrieval recovery guide (bloating, cramping management)",
    ],
    priceRange: { low: 3000, high: 5000 },
    currency: "USD",
    status: "coming-soon",
    steps: [
      {
        title: "Pre-procedure",
        description:
          "Nothing by mouth after midnight. Arrive 30 minutes early. Arrange a ride home.",
      },
      {
        title: "Retrieval",
        description:
          "Ultrasound-guided needle aspiration under sedation. Typically 15–20 minutes.",
      },
      {
        title: "Recovery",
        description:
          "Rest in recovery for 1–2 hours. Egg count reported same day. Plan for 1–2 days of rest.",
      },
    ],
  },
  sources: [
    {
      title: "Oocyte retrieval techniques and complications",
      journal: "Fertility and Sterility",
      year: 2022,
      evidenceLevel: "cohort",
    },
  ],
};

registerBlock(eggRetrieval);
